import { getGroupAuthType } from "@/utils/authToken";
import { httpAuth2 } from "@/api/auth";

import { GROUP_AUTH_HEADER_NAME } from "../constants";

export const carePlanRequests = {
  add_objective: ({ context, data, urlParams } = {}) => {
    return httpAuth2
      .post(`/v1/care-plan/${urlParams.patientId}/add_objective`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json();
  },

  change_modality: ({ context, data, urlParams } = {}) => {
    return httpAuth2
      .post(`/v1/care-plan/${urlParams.patientId}/change_modality`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json();
  },

  get_goal_and_objective_text: ({ context, urlParams } = {}) => {
    return httpAuth2
      .post(`/v1/care-plan/${urlParams.patientId}/get_goal_and_objective_text`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json();
  },

  get_goals_and_objectives: ({ context, urlParams } = {}) => {
    return httpAuth2
      .post(`/v1/care-plan/${urlParams.patientId}/get_goals_and_objectives`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json();
  },

  get_modality_text: ({ context, urlParams } = {}) => {
    return httpAuth2
      .post(`/v1/care-plan/${urlParams.patientId}/get_modality_text`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json();
  },

  get_patient_articulated_goals: ({ context, urlParams } = {}) => {
    return httpAuth2
      .post(`/v1/care-plan/${urlParams.patientId}/get_patient_articulated_goals`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json();
  },

  get_patient_medical_cautions: ({ context, urlParams } = {}) => {
    return httpAuth2
      .post(`/v1/care-plan/${urlParams.patientId}/get_patient_medical_cautions`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json();
  },

  get_patient_strength_and_caution_options: ({ context, urlParams } = {}) => {
    return httpAuth2
      .post(`/v1/care-plan/${urlParams.patientId}/get_patient_strength_and_caution_options`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json();
  },

  get_patient_strengths: ({ context, urlParams } = {}) => {
    return httpAuth2
      .post(`/v1/care-plan/${urlParams.patientId}/get_patient_strengths`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json();
  },

  update_and_add_objective: ({ context, data, urlParams } = {}) => {
    return httpAuth2
      .post(`/v1/care-plan/${urlParams.patientId}/update_and_add_objective`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json();
  },

  update_goal_and_objective: ({ context, data, urlParams } = {}) => {
    return httpAuth2
      .post(`/v1/care-plan/${urlParams.patientId}/update_goal_and_objective`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json();
  },

  update_objective: ({ context, data, urlParams } = {}) => {
    return httpAuth2
      .post(`/v1/care-plan/${urlParams.patientId}/update_objective`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json();
  },

  update_objective_meta_data: ({ context, data, urlParams } = {}) => {
    return httpAuth2
      .post(`/v1/care-plan/${urlParams.patientId}/update_objective_meta_data`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json();
  },

  update_patient_articulated_goals: ({ context, data, urlParams } = {}) => {
    return httpAuth2
      .post(`/v1/care-plan/${urlParams.patientId}/update_patient_articulated_goals`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json();
  },

  update_patient_medical_cautions: ({ context, data, urlParams } = {}) => {
    return httpAuth2
      .post(`/v1/care-plan/${urlParams.patientId}/update_patient_medical_cautions`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json();
  },

  update_patient_strengths: ({ context, data, urlParams } = {}) => {
    return httpAuth2
      .post(`/v1/care-plan/${urlParams.patientId}/update_patient_strengths`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json();
  },
};
